export function getRandomRGB(): string {
  const round = Math.round
  const r = Math.random
  const s = 255
  return 'rgba(' + round(r() * s) + ',' + round(r() * s) + ',' + round(r() * s) + ',0.5)'
}
